export default __webpack_public_path__ + "static/media/testimony_student_four.6cd98eaa.png";